import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LogoSVG from '../components/LogoSVG';

const ChevronRight = () => (
  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6"/>
  </svg>
);

export default function Trash() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [deleteAllConfirm, setDeleteAllConfirm] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [selected, setSelected] = useState({});
  const [deleteSelectedConfirm, setDeleteSelectedConfirm] = useState(false);

  useEffect(() => { fetchItems(); }, []);

  const fetchItems = async () => {
    try {
      const res = await axios.get('/api/trash/index.php', { withCredentials: true });
      setItems(res.data);
    } catch { navigate('/login'); }
  };

  const handleRestore = async (item) => {
    await axios.post('/api/trash/index.php', { action: 'restore', type: item.type, id: item.id }, { withCredentials: true });
    fetchItems();
  };

  const handleDelete = async (item) => {
    await axios.post('/api/trash/index.php', { action: 'delete', type: item.type, id: item.id }, { withCredentials: true });
    setDeleteConfirm(null); fetchItems();
  };

  const handleDeleteAll = async () => {
    await axios.delete('/api/trash/index.php', { withCredentials: true });
    setDeleteAllConfirm(false); fetchItems();
  };

  const toggleSelect = (item) => {
    const key = `${item.type}-${item.id}`;
    setSelected(p => {
      const next = { ...p };
      if (next[key]) delete next[key]; else next[key] = item;
      return next;
    });
  };

  const selectedCount = Object.keys(selected).length;

  const handleDeleteSelected = async () => {
    for (const item of Object.values(selected)) {
      await axios.post('/api/trash/index.php', { action: 'delete', type: item.type, id: item.id }, { withCredentials: true });
    }
    setSelected({}); setDeleteSelectedConfirm(false); fetchItems();
  };

  const typeLabel = { manager: '관리자 폴더', project: '프로젝트', video: '영상' };

  return (
    <div style={s.wrap}>
      <div style={s.topbar}>
        <div style={s.logoArea}>
          <LogoSVG size={32} />
          <div style={s.divider} />
          <span style={s.breadHome} onClick={() => navigate('/')}>WORKSPACE</span>
          <ChevronRight />
          <span style={s.breadCurrent}>휴지통</span>
        </div>
      </div>

      <div style={s.controlRow}>
        <span style={s.sectionLabel}>항목 {items.length}개</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginRight: 32 }}>
          {selectedCount > 0 && (
            <button style={s.deleteAllBtn} onClick={() => setDeleteSelectedConfirm(true)}>선택 삭제 ({selectedCount})</button>
          )}
          <button style={s.deleteAllBtn} onClick={() => setDeleteAllConfirm(true)}>전체 삭제</button>
        </div>
      </div>

      <div style={s.grid}>
        {items.length === 0 && <p style={s.empty}>휴지통이 비어있습니다</p>}
        {items.map(item => (
          <div key={`${item.type}-${item.id}`} style={s.card}>
            <div
              onClick={() => toggleSelect(item)}
              style={{ ...s.checkbox, background: selected[`${item.type}-${item.id}`] ? 'transparent' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {selected[`${item.type}-${item.id}`] && <svg width="10" height="10" viewBox="0 0 12 12"><polyline points="1,6 5,10 11,2" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>}
            </div>
            <div style={{ ...s.thumb, background: item.type === 'video' ? '#000' : 'transparent' }}>
              {item.type === 'video'
                ? (item.thumbnail_path
                  ? <img src={item.thumbnail_path} alt="" style={s.thumbImg} />
                  : <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.2" strokeLinecap="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>)
                : <svg width="40" height="40" viewBox="0 0 24 24" fill="#ffbc00"><path d="M2 9a2 2 0 0 1 2-2h4l2 2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9z"/></svg>}
            </div>
            <div style={s.cardBody}>
              <span style={s.cardName}>{item.name}</span>
              <span style={s.cardInfo}>{typeLabel[item.type]} · 삭제일 {new Date(item.deleted_at).toLocaleDateString()}</span>
              <div style={s.cardActions}>
                <button style={s.cardBtn} onClick={() => handleRestore(item)}>복구</button>
                <button style={{ ...s.cardBtn, ...s.cardBtnDanger }} onClick={() => setDeleteConfirm(item)}>영구삭제</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {deleteConfirm && (
        <div style={s.overlay} onClick={() => setDeleteConfirm(null)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalTitle}>영구 삭제</div>
            <div style={s.modalDesc}><strong style={{ color: '#fff' }}>{deleteConfirm.name}</strong>을(를) 영구삭제합니다.<br/>이 작업은 되돌릴 수 없습니다.</div>
            <div style={s.modalActions}>
              <button style={s.modalBtn} onClick={() => setDeleteConfirm(null)}>취소</button>
              <button style={{ ...s.modalBtn, ...s.modalBtnDanger }} onClick={() => handleDelete(deleteConfirm)}>영구삭제</button>
            </div>
          </div>
        </div>
      )}

      {deleteAllConfirm && (
        <div style={s.overlay} onClick={() => setDeleteAllConfirm(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalTitle}>전체 삭제</div>
            <div style={s.modalDesc}>휴지통의 모든 항목을 영구삭제합니다.<br/>이 작업은 되돌릴 수 없습니다.</div>
            <div style={s.modalActions}>
              <button style={s.modalBtn} onClick={() => setDeleteAllConfirm(false)}>취소</button>
              <button style={{ ...s.modalBtn, ...s.modalBtnDanger }} onClick={handleDeleteAll}>전체 삭제</button>
            </div>
          </div>
        </div>
      )}

      {deleteSelectedConfirm && (
        <div style={s.overlay} onClick={() => setDeleteSelectedConfirm(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalTitle}>선택 삭제</div>
            <div style={s.modalDesc}>선택한 {selectedCount}개 항목을 영구삭제합니다.<br/>이 작업은 되돌릴 수 없습니다.</div>
            <div style={s.modalActions}>
              <button style={s.modalBtn} onClick={() => setDeleteSelectedConfirm(false)}>취소</button>
              <button style={{ ...s.modalBtn, ...s.modalBtnDanger }} onClick={handleDeleteSelected}>선택 삭제</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  wrap: { minHeight: '100vh', background: '#191919', fontFamily: "'Pretendard', sans-serif", padding: 20 },
  topbar: { background: 'transparent', borderTop: '1px solid rgba(255,255,255,0.2)', borderBottom: '1px solid rgba(255,255,255,0.2)', padding: '0 18px', height: 56, display: 'flex', alignItems: 'center', marginBottom: 19 },
  logoArea: { display: 'flex', alignItems: 'center', gap: 10 },
  divider: { width: 1, height: 20, background: 'rgba(255,255,255,0.15)' },
  breadHome: { fontSize: 16, fontWeight: 600, color: 'rgba(255,255,255,0.3)', cursor: 'pointer', letterSpacing: '0.5px' },
  breadCurrent: { fontSize: 16, fontWeight: 400, color: '#fff', letterSpacing: '0.5px' },
  controlRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 17 },
  sectionLabel: { fontSize: '12px', color: 'rgba(255,255,255,0.4)' },
  deleteAllBtn: { background: 'none', border: '0.56px solid rgba(255,255,255,0.2)', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', color: 'rgba(255,255,255,0.6)', fontSize: 16, fontFamily: 'inherit' },
  grid: { display: 'flex', flexWrap: 'wrap', gap: 14 },
  empty: { color: 'rgba(255,255,255,0.25)', fontSize: '12px' },
  card: { background: 'transparent', border: '0.56px solid rgba(255,255,255,0.15)', borderRadius: 16, padding: '16px 18px', width: 240, display: 'flex', gap: 14, alignItems: 'flex-start' },
  checkbox: { width: 16, height: 16, marginTop: 2, cursor: 'pointer', flexShrink: 0, border: '1.5px solid rgba(255,255,255,0.6)', borderRadius: 3, background: 'transparent' },
  thumb: { flexShrink: 0, width: 64, height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8, overflow: 'hidden', background: '#000' },
  thumbImg: { width: '100%', height: '100%', objectFit: 'cover' },
  cardBody: { display: 'flex', flexDirection: 'column', gap: 5, flex: 1, minWidth: 0 },
  cardName: { color: 'rgba(255,255,255,0.7)', fontSize: '11pt', fontWeight: 400, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  cardInfo: { color: 'rgba(255,255,255,0.3)', fontSize: '11px' },
  cardActions: { display: 'flex', gap: 8, marginTop: 6 },
  cardBtn: { background: 'transparent', border: '0.56px solid rgba(255,255,255,0.12)', borderRadius: 6, padding: '5px 12px', color: 'rgba(255,255,255,0.4)', fontSize: '9pt', cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap' },
  cardBtnDanger: { borderColor: 'rgba(231,76,60,0.3)', color: 'rgba(231,76,60,0.6)' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  modal: { background: '#303030', border: '0.56px solid rgba(255,255,255,0.1)', borderRadius: 14, padding: '28px 24px', width: 320, boxShadow: '0 24px 60px rgba(0,0,0,0.5)' },
  modalTitle: { fontSize: '13pt', fontWeight: 600, color: '#fff', marginBottom: 10 },
  modalDesc: { fontSize: '10pt', color: 'rgba(255,255,255,0.45)', lineHeight: 1.6, marginBottom: 22 },
  modalActions: { display: 'flex', justifyContent: 'flex-end', gap: 8 },
  modalBtn: { fontSize: '10pt', padding: '8px 18px', borderRadius: 8, cursor: 'pointer', border: '0.56px solid rgba(255,255,255,0.15)', background: 'transparent', color: 'rgba(255,255,255,0.5)', fontFamily: 'inherit' },
  modalBtnDanger: { background: '#e74c3c', color: '#fff', borderColor: '#e74c3c' },
};
